var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.23472 1.16998H6.79186L6.6005 0.766765C6.55997 0.680562 6.49752 0.608049 6.4202 0.557385C6.34288 0.506721 6.25374 0.479915 6.16282 0.479984H3.836C3.74529 0.479615 3.65631 0.50632 3.57926 0.557041C3.50221 0.607761 3.44021 0.680445 3.40036 0.766765L3.209 1.16998H0.766144C0.679759 1.16998 0.596912 1.20633 0.535829 1.27103C0.474746 1.33573 0.44043 1.42348 0.44043 1.51498L0.44043 2.20498C0.44043 2.29648 0.474746 2.38424 0.535829 2.44894C0.596912 2.51364 0.679759 2.54998 0.766144 2.54998H9.23472C9.3211 2.54998 9.40395 2.51364 9.46503 2.44894C9.52611 2.38424 9.56043 2.29648 9.56043 2.20498V1.51498C9.56043 1.42348 9.52611 1.33573 9.46503 1.27103C9.40395 1.20633 9.3211 1.16998 9.23472 1.16998ZM1.52343 10.5497C1.53896 10.8124 1.64846 11.059 1.82961 11.2393C2.01077 11.4196 2.24998 11.5199 2.49854 11.52H7.50232C7.75088 11.5199 7.99009 11.4196 8.17125 11.2393C8.3524 11.059 8.46189 10.8124 8.47743 10.5497L8.909 3.23998H1.09186L1.52343 10.5497Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.81accac2b8f4df137edd0eea54aebec3.svg";
export { ForwardRef as ReactComponent };